<template>
    <div class="shop-authentication">
        <div class="title-container">
            <div class="line"></div>
            <span class="title"> 商家入驻</span>
        </div>
        <div class="step-class">
            <el-steps :active="active" align-center style="text-align: left;">
                <el-step title="实名认证"></el-step>
                <el-step title="填写店铺信息"></el-step>
                <el-step title="提交审核"></el-step>
            </el-steps>
        </div>
        <el-form :model="infoForm" label-position="top" ref="infoForm" :rules="infoFormRules">
            <div class="form-row">
                <el-form-item prop="name" label="姓名" style="width: 45%;">
                    <el-input v-model="infoForm.name" placeholder="请填写"></el-input>
                </el-form-item>
                <el-form-item prop="phone" label="手机号" style="width: 45%;">
                    <el-input v-model="infoForm.phone" placeholder="请填写" maxLength="11"></el-input>
                </el-form-item>
                <el-form-item prop="idCard" label="身份证号" style="width: 45%;">
                    <el-input v-model="infoForm.idCard" placeholder="请填写" maxLength="18"></el-input>
                </el-form-item>
            </div>
            <div class="form-row" style="margin-top: 20px;">
                <el-form-item prop="idCardFront" label="身份证人像面" style="width: 45%;">
                    <div class="upload-container">
                        <image-upload :image-url="infoForm.idCardFront" :default-image="defaultAvatar"
                            @upload-success="handleAvatarUpload(1, $event)" :max-files="1" />
                    </div>
                </el-form-item>
                <el-form-item prop="idCardBack" label="身份证国徽面" style="width: 45%;">
                    <div class="upload-container">
                        <image-upload :image-url="infoForm.idCardBack" :default-image="defaultAvatar"
                            @upload-success="handleAvatarUpload(2, $event)" :max-files="1" />
                    </div>
                </el-form-item>
            </div>

            <div class="form-actions">
                <el-button type="primary" @click="nextStep">下一步</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { phoneRules } from '@/utils/validate'
import ImageUpload from '@/components/ImageUpload.vue'
export default {
    name: 'ShopAuthentication',
    components: { ImageUpload },
    props: {
        certified: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            active: 0,
            infoFormRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                phone: phoneRules(),
                idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
                idCardFront: [{ required: true, message: '请上传身份证人像面', trigger: 'change' }],
                idCardBack: [{ required: true, message: '请上传身份证国徽面', trigger: 'change' }]
            },
            infoForm: {
                name: '',
                phone: '',
                idCard: '',
                idCardFront: '',
                idCardBack: ''
            },
            defaultAvatar: "",
        }
    },
    mounted() {
        if (this.certified === '3') {
            this.getShopInfo();
        }
    },
    methods: {
        getShopInfo() {
            this.$api.getShopReviewInfo().then(res => {
                this.infoForm.name = res.contacts_name;
                this.infoForm.phone = res.contacts_phone;
                this.infoForm.idCard = res.idcard_no;
                this.infoForm.idCardFront = res.idcard_front;
                this.infoForm.idCardBack = res.idcard_reverse;
            }).catch(err => {
                this.$message.warning(err)
            })
        },
        handleAvatarUpload(index, imageUrl) {
            if (index === 1) {
                this.infoForm.idCardFront = imageUrl[0];
            } else if (index === 2) {
                this.infoForm.idCardBack = imageUrl[0];
            }
        },
        nextStep() {
            this.$refs.infoForm.validate((valid) => {
                if (valid) {
                    this.$api.realName({
                        contacts_name: this.infoForm.name,
                        contacts_phone: this.infoForm.phone,
                        idcard_no: this.infoForm.idCard,
                        idcard_front: this.infoForm.idCardFront,
                        idcard_reverse: this.infoForm.idCardBack
                    }).then(res => {
                        this.$emit('goToComponent', 'ShopInformation',{ certified: this.certified });
                    }).catch(err => {
                        this.$message.warning(err)
                    })
                } else {
                    this.$message.warning('请填写完整信息');
                }
            });
        }
    }
}
</script>

<style scoped>
.shop-authentication {
    max-width: 800px;
    margin: 0 auto;
}

.step-class {
    width: 100%;
    margin: 32px 0;
}

.form-row {
    width: 100%;
    display: flex;
    align-items: center;
    text-align: left;
    flex-wrap: wrap;
    gap: 20px;
}

.upload-container {
    margin-top: 10px;
}

.form-actions {
    text-align: center;
    margin-top: 40px;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

.title-container {
    display: flex;
    align-items: center;
}

.title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-left: 10px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>